import { render } from "./PublicationAdd.vue?vue&type=template&id=1ca2890c&scoped=true"
import script from "./PublicationAdd.vue?vue&type=script&lang=js"
export * from "./PublicationAdd.vue?vue&type=script&lang=js"

import "./PublicationAdd.vue?vue&type=style&index=0&id=1ca2890c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca2890c"]])

export default __exports__